<template>
  <div class="detailsBox">
    <div class="topSearch">
      <van-icon name="arrow-left" @click="goHistroy" />
      <van-search
        class="searchInput"
        v-model="questionObj.title"
        background="#fff"
        placeholder="请输入搜索关键词"
        @click="goSearch"
      />
    </div>
    <!-- 内容区 -->
    <div class="contentBox">
      <div class="bgTit">
          <img src="../assets/image/questionIcon.png" class="questionIcon" />
          <h4>
            {{ questionObj.title }}
          </h4>
        </div>
      <div
        class="content"
        v-if="questionObj.type == 2"
        v-html="questionObj.answer"
      ></div>
      <div class="content" v-if="questionObj.type == 1">
        {{ questionObj.answer }}
      </div>
    </div>
    <div class="bottomText"> 本话术库由汇添富基金联合启势广告开发<br />
      版权所有。基金有风险，投资须谨慎</div>
      <tab></tab>
  </div>
</template>

<script>
import { answerDetails } from "@/api/index";
import tab from "@/components/tab";
export default {
  name: "details",
  components: { tab },
  data() {
    return {
      msg: "基金啊，这个相比理财，不是风险很大吗？",
      id: null,
      questionObj: {
        title: "",
        answer: "",
      },
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getDetails(this.id);
  },
  methods: {
    goHistroy() {
      this.$router.go(-1);
    },
    getDetails(id) {
      answerDetails({ id: id, type: 1 })
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            // this.handleSpeak(res.data.top_news.title)
            // this.handleSpeak(res.data.top_news.answer)
            this.questionObj = res.data.top_news;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    goSearch() {
      this.$router.push({
        path: "/search",
        query: {
          msg: this.questionObj.title,
        },
      });
    },
  },
};
</script>
<style lang="less">
img {
  max-width: 100%;
  height: auto;
}
</style>
<style lang="less" scoped>
.detailsBox {
  // height: 100vh;
  position: relative;
  width: 94%;
  margin: 0 auto 2.5rem;
  padding-bottom: 3.5rem;
  .topSearch {
    display: flex;
    align-items: center;
    .searchInput {
      flex: 2;
      margin-left: 0.625rem;
    }
  }
  .van-search {
    padding: 0.625rem 0;
  }
  .van-search__content {
    padding-left: 0;
    background: #fff;
  }
  .van-search .van-cell {
    line-height: 2rem;
    background: #f4f4f4;
    border-radius: 3.125rem;
    padding: 0 0.625rem;
    box-sizing: border-box;
  }
  .contentBox {
    background: #fff;
    margin: 0.6rem 0;
    border-radius: 0.9375rem;
    height: auto;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.12);
    // padding: 0.3125rem 0.9375rem;
    box-sizing: border-box;
    overflow: hidden;
    .bgTit {
        padding: 0.3125rem 0.5rem;
        display: flex;
        align-items: flex-start;
        line-height: 1.8625rem;
        background: #f6f6f6;
        h4 {
          margin: 0;
        }
        .questionIcon {
          display: inline-block;
          width: 1.125rem;
          height: 1.25rem;
          margin-right: 0.5rem;
          margin-top: 0.38rem;
        }
      }
    .content {
      line-height: 1.5625rem;
      padding: 0.3125rem 0.9375rem;
      box-sizing: border-box;
      width: 100%;
      img {
        max-width: 12.5rem;
      }
    }
  }
  .bottomText {
    position: absolute;
    width: 100%;
    text-align: center;
    font-size: 0.75rem;
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/details.vue